"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOTOR_COVER_TIERS = void 0;
exports.initCoverTiers = initCoverTiers;
let _tiers = null;
function getTiers() {
    if (_tiers === null) {
        throw new Error('MOTOR_COVER_TIERS not initialized. Call initCoverTiers() during app startup.');
    }
    return _tiers;
}
exports.MOTOR_COVER_TIERS = {
    get MOTOR_TIER_1() {
        return getTiers().MOTOR_TIER_1;
    },
    get MOTOR_TIER_2() {
        return getTiers().MOTOR_TIER_2;
    },
    get MOTOR_TIER_3() {
        return getTiers().MOTOR_TIER_3;
    }
};
function initCoverTiers() {
    if (_tiers) {
        return;
    }
    const raw = process.env.REACT_APP_MOTOR_COVER_TIERS;
    if (!raw) {
        throw new Error('REACT_APP_MOTOR_COVER_TIERS is not defined');
    }
    const decodedStr = atob(raw);
    let parsed;
    try {
        parsed = JSON.parse(decodedStr);
    }
    catch (_a) {
        throw new Error('REACT_APP_MOTOR_COVER_TIERS is not valid JSON: ' + raw);
    }
    if (typeof parsed !== 'object' ||
        parsed === null ||
        !('MOTOR_TIER_1' in parsed) ||
        !('MOTOR_TIER_2' in parsed) ||
        !('MOTOR_TIER_3' in parsed)) {
        throw new Error('REACT_APP_MOTOR_COVER_TIERS must contain MOTOR_TIER_1, MOTOR_TIER_2, MOTOR_TIER_3');
    }
    _tiers = parsed;
}
//# sourceMappingURL=motorCoverTiers.js.map